module.exports = __webpack_public_path__ + "media/video-thumbnails/3-ff8c8686.gif";